import request from '@/utils/request'

let Technician = {
	// 动态列表
	Dynamic(data, errorback){
	  return request._get('/shop/waiter.Dynamic/index', data, errorback);
	},
	// 动态列表删除
	del(data, errorback){
	  return request._get('/shop/waiter.Dynamic/del', data, errorback);
	},
	// 动态列表审核
	audit(data, errorback){
	  return request._post('/shop/waiter.Dynamic/audit', data, errorback);
	},
	// 迁移申请列表
	CityLog(data, errorback){
	  return request._post('/shop/waiter.CityLog/index', data, errorback);
	},
	
	// 迁移申请列表审核
	examine(data, errorback){
	  return request._post('/shop/waiter.CityLog/examine', data, errorback);
	},
	
	
	
	
	
  /*添加技师*/ // 修改技师
  // addWaiter(data, errorback) {
  //   return request._post('/shop/Waiter/addWaiter', data, errorback);
  // },
  addwaiter(data, errorback){
    return request._post('/shop/waiter.User/add', data, errorback);
  }, 
  // 查询技师 废弃
  getWaiter(data, errorback) {
    return request._post('/shop/Waiter/getWaiter', data, errorback);
  },
  getnewWaiter(data, errorback) {
    return request._get('/shop/waiter.user/index', data, errorback);
  },

  // 查询技师
  Technician(data, errorback) {
    return request._post('/shop/Waiter/getWaiter', data, errorback);
  },
  // 查询技师详情
  getWaiterInfo(data, errorback) {
    return request._post('/shop/Waiter/getWaiterInfo', data, errorback);
  },
  getnewWaiterInfo(data, errorback) {
    return request._get('/shop/waiter.user/details', data, errorback);
  },

  // 刪除技师 废弃
  deleteWaiter(data, errorback) {
    return request._post('/shop/Waiter/deleteWaiter', data, errorback);
  },
  deletenewWaiter(data, errorback) {
    return request._get('/shop/waiter.user/del', data, errorback);
  },
  // shop/Waiter/addWaiter
  editWaiter(data, errorback) {

    return request._post('/shop/Waiter/editWaiter', data, errorback);
  },
  // 更新技师
  updateWaiterUserId(data, errorback) {
    return request._post('/shop/order.order/updateWaiterUserId', data, errorback);
  },
  // 添加城市
  addCity(data, errorback) {
    return request._post('/shop/ServiceCity/addCity', data, errorback);
  },
  // 获取城市列表
  getCity(data, errorback) {
    return request._get('/shop/ServiceCity/getCity', data, errorback);
  },
  // 删除城市
  deleteCity(data, errorback) {
    return request._post('/shop/ServiceCity/deleteCity', data, errorback);
  },

  // 修改客服电话
  mp_service(data, errorback) {
    return request._post('/shop/setting.mpservice/index', data, errorback);
  },
  // 修改客服电话
  mp_service2(data, errorback) {
    return request._get('/shop/setting.mpservice/index', data, errorback);
  },


  // 技师等级列表
  technicianlevel(data, errorback) {
    return request._post('/shop/level.level/index', data, errorback);
  },
  techniciandetail(data, errorback) {
    return request._get('/shop/level.level/detail', data, errorback);
  },
  // 技师等级
  technicianadd(data, errorback) {
    return request._post('/shop/level.level/add', data, errorback);
  }, // 技师等级
  technicianedit(data, errorback) {
    return request._post('/shop/level.level/edit', data, errorback);
  }, // 技师等级
  techniciandelete(data, errorback) {
    return request._post('/shop/level.level/delete', data, errorback);
  },
  // 保证金添加
  bondAdd(data, errorback) {
    return request._post('/shop/money.money/edit', data, errorback);
  },
  // 保证金获取详情
  bondEdit(data, errorback) {
    return request._get('/shop/money.money/edit', data, errorback);
  },

  // 课程分类添加
  courseCategoryAdd(data, errorback) {
    return request._post('/shop/lesson.Category/add', data, errorback);
  },
  // 课程分类编辑
  courseCategoryEdit(data, errorback) {
    return request._post('/shop/lesson.Category/edit', data, errorback);
  },
  // 课程分类删除
  courseCategoryDel(data, errorback) {
    return request._post('/shop/lesson.Category/delete', data, errorback);
  },
  // 课程分类列表（不分页）
  coursegetCategory(data, errorback) {
    return request._get('/shop/lesson.Category/getCategory', data, errorback);
  },
  // 课程分类列表
  courseCategoryList(data, errorback) {
    return request._post('/shop/lesson.Category/index', data, errorback);
  },
  // 课程分类详情
  courseCategoryDetail(data, errorback) {
    return request._get('/shop/lesson.Category/detailData', data, errorback);
  },

  // 课程添加
  courselessonAdd(data, errorback) {
    return request._post('/shop/lesson.lesson/add', data, errorback);
  },
  // 课程编辑
  courselessonEdit(data, errorback) {
    return request._post('/shop/lesson.lesson/edit', data, errorback);
  },
  // 课程删除
  courselessonDel(data, errorback) {
    return request._post('/shop/lesson.lesson/delete', data, errorback);
  },
  // 课程列表
  courselessonList(data, errorback) {
    return request._get('/shop/lesson.lesson/index', data, errorback);
  },
  // 课程详情
  courselessonDetail(data, errorback) {
    return request._get('/shop/lesson.lesson/detailData', data, errorback);
  },
  // 在线时长
  timewaiterList(data, errorback) {
    return request._post('/shop/waiter.user/waiterList', data, errorback);
  },
  // 查看
  timeworkLog(data, errorback) {
    return request._post('/shop/waiter.user/workLog', data, errorback);
  },
  // 上下线
  Onlinelog(data, errorback) {
    return request._post('/shop/waiter.Online/index', data, errorback);
  },
  // 技师考核
  Levelwaiter(data, errorback) {
    return request._post('/shop/level.LevelSetting/index', data, errorback);
  },
  // 技师考核
  Levelwaiteredit(data, errorback) {
    return request._post('/shop/level.LevelSetting/index', data, errorback);
  },
  // 技师编辑
  waiteredit(data, errorback) {
    return request._post('/shop/waiter.user/edit', data, errorback);
  },
  // 技师更改密码
  changePassword(data, errorback) {
    return request._post('/shop/waiter.user/changePassword', data, errorback);
  },
  // 修改技师余额
  recharge(data, errorback) {
    return request._post('/shop/waiter.user/recharge', data, errorback);
  },
  // 技师状态
  getWorkTime(data, errorback) {
    return request._get('/shop/waiter.user/getWorkTime', data, errorback);
  },
  postWorkTime(data, errorback) {
    return request._post('/shop/waiter.user/getWorkTime', data, errorback);
  },
  // 技师统计
  statistics(data, errorback) {
    return request._get('/shop/waiter.user/statistics', data, errorback);
  },
  // 技师位置
  getPositionData(data, errorback) {
    return request._get('/shop/Technician/getPositionData', data, errorback);
  },
  savePositionData(data, errorback) {
    return request._post('/shop/Technician/savePositionData', data, errorback);
  },
  // 技师轨迹
  getdrivingTrack(data, errorback) {
    return request._post('/shop/waiter.user/drivingTrack', data, errorback);
  },
  // 服务项目筛选
  changeProduct(data, errorback) {
    return request._post('/shop/waiter.user/getProduct', data, errorback);
  },
   //设置用户黑名单
   jssetblack(data, errorback){
    return request._post('/shop/waiter.user/isBlack', data, errorback);
  },
  //设置技师可服务范围
  getjsscope(data, errorback){
    return request._get('/shop/waiter.user/scope', data, errorback);
  },
   //设置技师可服务范围
   jsscope(data, errorback){
    return request._post('/shop/waiter.user/scope', data, errorback);
  }


}
export default Technician;



// WEBPACK FOOTER //
// ./src/api/technician.js